import LocalizedStrings from 'react-localization';

export let strings = new LocalizedStrings({
    en: {
        facebookConnect: {
            heading: 'Link your chatbot to Facebook',
            text: 'You need to connect your Facebook account to Frankie. By doing that, we will be able to read the Facebook pages where you are an administrator.',
            buttonText: 'Link Facebook account'
        },
        facebookPages: {
            heading: 'Your Facebook pages',
            text: 'Select the page where you want to install the current chatbot.'
        }
    },
    es: {
        facebookConnect: {
            heading: 'Contecta tu chatbot a Facebook',
            text: 'Necesitas conectar tu cuenta de Facebook a Frankie. Con esto, podremos obtener las páginas de Facebook que administras.',
            buttonText: 'Conectar cuenta de Facebook'
        },
        facebookPages: {
            heading: 'Tus páginas de Facebook',
            text: 'Selecciona la página donde quieres instalar tu chatbot.'
        }
    }
});


// WEBPACK FOOTER //
// ./src/redux/components/pages/DashboardFacebook/DashboardFacebookContent.js